import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           60 * 1000, // 1 min — évite les refetch immédiats sur remontage (StrictMode, navigation)
      refetchOnWindowFocus: false,    // évite les refetch à chaque alt-tab
      retry:               false,     // une seule tentative (cohérent avec les hooks existants)
    },
  },
});